import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { TimerIcon } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const DURATION = 60 * 60 * 1000; // 1 hora en ms
    const STORAGE_KEY = 'urgency_timer_start';
    let start = localStorage.getItem(STORAGE_KEY);
    if (!start) {
      start = Date.now().toString();
      localStorage.setItem(STORAGE_KEY, start);
    }
    const endTime = parseInt(start) + DURATION;
    const calculateTimeLeft = () => {
      const diff = Math.max(0, endTime - Date.now());
      return {
        hours: Math.floor(diff / (1000 * 60 * 60) % 24),
        minutes: Math.floor(diff / 1000 / 60 % 60),
        seconds: Math.floor(diff / 1000 % 60)
      };
    };
    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (value: number) => value.toString().padStart(2, '0');
  return <motion.div initial={{
    y: -50
  }} animate={{
    y: 0
  }} className="sticky top-0 z-50 w-full bg-[#0A0A0A] border-b border-[#1A7A4A]/30 py-3 px-4 shadow-[0_4px_20px_rgba(26,122,74,0.15)]" data-id="element-197">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 text-center" data-id="element-198">
        <motion.div animate={{
        opacity: [1, 0.7, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} className="flex items-center text-[#C9A84C] font-bold text-sm md:text-base tracking-wide" data-id="element-199">
          <span className="mr-2" data-id="element-200">🔥</span>
          Descuento del 70% — se acaba en menos de 1 hora
          <span className="ml-2" data-id="element-201">🔥</span>
        </motion.div>

        <div className="flex items-center gap-2 bg-neutral-900 px-3 py-1 rounded-md border border-[#1A7A4A]/20" data-id="element-202">
          <TimerIcon className="w-4 h-4 text-[#C9A84C]" data-id="element-203" />
          <span className="font-mono font-bold text-[#C9A84C]" data-id="element-204">
            {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
            {formatTime(timeLeft.seconds)}
          </span>
        </div>
      </div>
    </motion.div>;
}